

import React from "react";
import { Box, Button, Typography, Card, CardContent } from "@mui/joy";

const CADStandardsAssistant = () => {
  const handleLaunch = () => {
    window.open("https://chatgpt.com/g/g-685bf099c7e08191b71e02342cf92acc-fld-p-cad-standards-assistant", "_blank");
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Card variant="outlined" sx={{ maxWidth: 500 }}>
        <CardContent>
          <Typography level="h4" gutterBottom>
            CAD Standards Assistant
          </Typography>
          <Typography level="body1" gutterBottom>
            Use this assistant to ask about FLD&P’s CAD layer names, linetypes, and drafting policies.
          </Typography>
          <Typography level="body2" fontStyle="italic" gutterBottom>
            Try: "What layer should I use for existing utilities?"
          </Typography>
          <Button onClick={handleLaunch} variant="solid" color="primary">
            Launch Assistant
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CADStandardsAssistant;